// Vendor libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../directives/disabled/disabled.directive";
import * as i3 from "@angular/forms";
import * as i4 from "../../modals/help-modal/components/help-modal.component";
function RadioButtonGroupComponent_label_0_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵlistener("click", function RadioButtonGroupComponent_label_0_span_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r3); const radioButton_r4 = i0.ɵɵnextContext().$implicit; i0.ɵɵnextContext(); const help_r5 = i0.ɵɵreference(2); return i0.ɵɵresetView(help_r5.openModal(radioButton_r4.help_modal_name)); });
    i0.ɵɵtext(3, "(?)");
    i0.ɵɵelementEnd()();
} }
function RadioButtonGroupComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 2)(1, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function RadioButtonGroupComponent_label_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.selectedValue, $event) || (ctx_r1.selectedValue = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function RadioButtonGroupComponent_label_0_Template_input_ngModelChange_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectHandler.emit(ctx_r1.selectedValue)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, RadioButtonGroupComponent_label_0_span_5_Template, 4, 0, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const radioButton_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("text-nowrap", radioButton_r4.help_modal_name);
    i0.ɵɵproperty("disabled", ctx_r1.inputDisabled || radioButton_r4.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.inputDisabled || !!radioButton_r4.disabled)("name", ctx_r1.groupName)("value", radioButton_r4.value);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedValue);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(radioButton_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", radioButton_r4.help_modal_name);
} }
/**
 *
 * Radio Button Group Component
 *
 * Input Properties:
 *
 *  inputDisabled: Whether all buttons should be disabled or not
 *  groupName: The name that should be used for all buttons in this radio group. NOTE: If there are multiple
 *             radio groups on the same page, they must all use different groupNames.
 *  options: An array of RadioButtons that contains values and labels for each option
 *  selectedObject: A RadioButton (no label necessary) representing the selected value.
 *
 *
 * Output Properties:
 *
 *  selectHandler: EventEmitter that emits the selected value
 *
 */
export class RadioButtonGroupComponent {
    constructor() {
        this.selectHandler = new EventEmitter();
        this.selectedValue = ''; // Used to pass the selected value to ngModel
    }
    ngOnChanges(changes) {
        if (changes.selectedObject) {
            // If no default option is set, do not select any radio buttons.
            if (this.selectedObject.value === '' || this.selectedObject.value === undefined) {
                this.selectedValue = '';
            }
            else {
                // Otherwise, find and select the default option.
                for (let i = 0; i < this.options.length; i += 1) {
                    if (this.options[i].value === this.selectedObject.value) {
                        this.selectedValue = this.options[i].value;
                        break;
                    }
                }
            }
        }
    }
}
RadioButtonGroupComponent.ɵfac = function RadioButtonGroupComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RadioButtonGroupComponent)(); };
RadioButtonGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RadioButtonGroupComponent, selectors: [["ycn-radio-button-group"]], inputs: { groupName: "groupName", inputDisabled: "inputDisabled", options: "options", selectedObject: "selectedObject" }, outputs: { selectHandler: "selectHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["help", ""], ["class", "custom-control custom-radio text-nowrap", "ycnDisabled", "", 3, "text-nowrap", "disabled", 4, "ngFor", "ngForOf"], ["ycnDisabled", "", 1, "custom-control", "custom-radio", "text-nowrap", 3, "disabled"], ["type", "radio", 1, "custom-control-input", 3, "ngModelChange", "disabled", "name", "value", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [4, "ngIf"], [1, "help-toggler", 3, "click"]], template: function RadioButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RadioButtonGroupComponent_label_0_Template, 6, 9, "label", 1);
        i0.ɵɵelement(1, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.options);
    } }, dependencies: [i1.NgForOf, i1.NgIf, i2.DisabledDirective, i3.DefaultValueAccessor, i3.RadioControlValueAccessor, i3.NgControlStatus, i3.NgModel, i4.HelpModalComponent], encapsulation: 2 });
